import { ProfileIdentificationStatusAPIModel } from '@/generated/api/fps/api';
import { actionCreator } from '@/utils/redux';

import { Confirmation, ConfirmationState, IdentificationState, NAMESPACE } from './types';

const creator = actionCreator(NAMESPACE);

export type SaveStateActionPayload = { state: IdentificationState };
export type SaveProfileStatusActionPayload = ProfileIdentificationStatusAPIModel;
export type StorePhoneActionPayload = { phone: string };
export type StoreInitializationActionPayload = {
  phone?: { value: string };
  identificationState?: IdentificationState;
  profileIdentificationStatus?: ProfileIdentificationStatusAPIModel;
  confirmation?: Confirmation;
};

export type CheckConfirmationActionPayload = { code: string };
export type SaveConfirmationStateActionPayload = {
  state: ConfirmationState;
  phone: string;
  attempt?: number;
  validTill?: Date;
  resendAfter?: Date;
};

// sagas
export const updatePhoneAndRequestConfirm = creator.asyncAction<void>('UPDATE_PHONE');
export const sendConfirmationRequest = creator.asyncAction<void>('SEND_CONFIRMATION');
export const checkConfirmationCode = creator.asyncActionWithPayload<CheckConfirmationActionPayload, void>(
  'CHECK_CONFIRMATION',
);

// reducers
export const storeFormPhone = creator.syncActionWithPayload<StorePhoneActionPayload>('STORE_FORM_PHONE');
export const storeSavedPhone = creator.syncActionWithPayload<StorePhoneActionPayload>('STORE_SAVED_PHONE');
export const storeIdentificationState = creator.syncActionWithPayload<SaveStateActionPayload>('STORE_STATE');
export const storeProfileIdentificationStatus = creator.syncActionWithPayload<SaveProfileStatusActionPayload>(
  'STORE_PROFILE_STATUS',
);
export const storeConfirmationState = creator.syncActionWithPayload<SaveConfirmationStateActionPayload>(
  'STORE_CONFIRMATION_STATE',
);
export const storeInitialization = creator.syncActionWithPayload<StoreInitializationActionPayload>('STORE_INIT');
export const storeLogout = creator.syncAction('STORE_LOGOUT');

// notifications
export const notifyInitializationFinished = creator.syncAction('INIT_FINISHED');
export const notifyIdentificationPassed = creator.syncAction('IDENTIFICATION_PASSED');

export default {
  updatePhoneAndRequestConfirm,
  sendConfirmationRequest,
  checkConfirmationCode,
  storeFormPhone,
  storeIdentificationState,
  storeInitialization,
  storeConfirmationState,
  storeLogout,
  notifyInitializationFinished,
  notifyIdentificationPassed,
};
